const STATIC_ASSET_URL = `//greenroom-static-assets.greenroom-dev.brandlive.cloud`;

export const stylePackBannerImages: Record<string, string> = {
  'brandlive-back-to-school': `${STATIC_ASSET_URL}/title_templates/back-to-school/back-to-school-banner-image-slim.png`,
  'brandlive-topo': `${STATIC_ASSET_URL}/title_templates/topo/topo-banner-image-slim.png`,
  'brandlive-rothko': `${STATIC_ASSET_URL}/title_templates/rothko/rothko-banner-image-slim.png`,
  'brandlive-academy': `${STATIC_ASSET_URL}/title_templates/academy/academy-banner-image-slim.png`,
  'brandlive-go-wow': `${STATIC_ASSET_URL}/title_templates/go-wow/go-wow-banner-image.png`,
  'brandlive-mondrian': `${STATIC_ASSET_URL}/title_templates/mondrian/mondorian-banner-image-slim.png`,
  'brandlive-tic-tac-toe': `${STATIC_ASSET_URL}/title_templates/tic-tac-toe/tic-tac-toe-banner-image-slim.png`,
};
